export class EmailAddress {
  emailAddress: string;
  fullName: string;

  constructor(values: object = {}) {
    Object.assign(this, values);
  }
}
